const AnnouncementMemberType = {
  MEMBER: 0,
  EXCLUDE: 1
}

export {
  AnnouncementMemberType
}



// WEBPACK FOOTER //
// ./src/enums/AnnouncementMemberType.js